import styled from '@emotion/styled';

const SpinnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 240px;
`;

const SpinnerCircle = styled.div`
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3d1690;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const LoadingText = styled.div`
  margin-top: 16px;
  font-size: 16px;
  color: #3d1690;
  font-family: 'Plus Jakarta Sans', sans-serif;
`;

export const Spinner = () => (
  <SpinnerWrapper>
    <SpinnerCircle />
    <LoadingText>Loading...</LoadingText>
  </SpinnerWrapper>
);
